import { render, staticRenderFns } from "./IconClose.vue?vue&type=template&id=b52cdd6c&"
import script from "./IconClose.vue?vue&type=script&lang=js&"
export * from "./IconClose.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/Kristian/Local Sites/boligvelger/app/public/wp-content/plugins/ensign-boligprosjekter-blocks/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b52cdd6c')) {
      api.createRecord('b52cdd6c', component.options)
    } else {
      api.reload('b52cdd6c', component.options)
    }
    module.hot.accept("./IconClose.vue?vue&type=template&id=b52cdd6c&", function () {
      api.rerender('b52cdd6c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/IconClose.vue"
export default component.exports